'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./white-labeling.scss');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _whiteLabeling = require('hellosign/components/api/white-labeling');

var _whiteLabeling2 = _interopRequireDefault(_whiteLabeling);

var _marketoForm = require('hellosign/components/marketo-form');

var _marketoForm2 = _interopRequireDefault(_marketoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('div', {
    className: 'm-white-labeling--contact-modal--overlay'
});

var _ref2 = _jsx(_marketoForm2['default'], {
    formId: 1139
});

var _ref3 = _jsx(_whiteLabeling2['default'], {});

var _ref4 = _jsx(_marketoForm2['default'], {
    formId: 1157
});

module.exports = function (_React$Component) {
    _inherits(WhiteLabelingLandingPage, _React$Component);

    function WhiteLabelingLandingPage(props) {
        _classCallCheck(this, WhiteLabelingLandingPage);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(WhiteLabelingLandingPage).call(this, props));

        _this.state = {
            'contactUsModalIsShown': false
        };
        return _this;
    }

    _createClass(WhiteLabelingLandingPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var q = document.location.search;
            if (q && q.indexOf('aliId=') >= 0) {
                document.location.hash = '';
                this.closeContactUsModal();
            }

            this.timerId = setInterval(function () {
                var h = document.location.hash;
                if (h === '#contact-us') {
                    _this2.openContactUsModal();
                }
            }, 100);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this.timerId);
        }
    }, {
        key: 'openContactUsModal',
        value: function openContactUsModal() {
            this.setState({
                'contactUsModalIsShown': true
            });
        }
    }, {
        key: 'closeContactUsModal',
        value: function closeContactUsModal() {
            this.setState({
                'contactUsModalIsShown': false
            });
        }
    }, {
        key: 'render',
        value: function render() {

            var modalClassNames = (0, _classnames2['default'])({
                'm-white-labeling--contact-modal': true,
                'is-shown': this.state.contactUsModalIsShown === true
            });

            var contactUsModal = _jsx('div', {
                className: modalClassNames
            }, void 0, _ref, _jsx('div', {
                className: 'm-white-labeling--contact-modal--form'
            }, void 0, _jsx('div', {
                className: 'm-white-labeling--contact-modal--form--header'
            }, void 0, 'Contact us'), _jsx('a', {
                href: '#',
                onClick: this.closeContactUsModal.bind(this),
                className: 'm-white-labeling--contact-modal--form--close'
            }, void 0, 'x'), _ref2));

            return _jsx('div', {
                className: 'm-white-labeling'
            }, void 0, _jsx('header', {}, void 0, _jsx('h1', {}, void 0, _jsx('span', {
                className: 'm-white-labeling-try'
            }, void 0, 'Try '), 'HelloSign\'s API White Labeling'), _jsx('h2', {}, void 0, 'Our signer page is customizable so it matches your color scheme exactly.'), _jsx('a', {
                href: '#contact-us'
            }, void 0, _jsx('button', {
                className: 'bg-cerulean c-white hc-white hbg-velvet-evening'
            }, void 0, 'Contact Us'))), _jsx('main', {}, void 0, contactUsModal, _ref3, _jsx('div', {
                className: 'm-white-labeling-copy'
            }, void 0, _jsx('div', {
                className: 'm-white-labeling-bulb-computer'
            }, void 0, _jsx('img', {
                src: require('../assets/bulb_icon.png'),
                'aria-hidden': true,
                className: 'white-labeling-bulb-icon'
            }), _jsx('span', {}, void 0, 'To try the interactive demo, please use your computer.')), _jsx('div', {
                className: 'm-white-labeling-copy-text'
            }, void 0, _jsx('p', {}, void 0, 'We\'re dedicated to powering effortless document workflows from end-to-end. White labeling is just one feature empowering you to make your product or service easier for your users.'), _jsx('p', {}, void 0, 'HelloSign\'s white labeling feature allows API users to customize a signing flow with their branding, colors, and logo. That means your signers/users can seamlessly complete forms directly on your site. HelloSign is the only eSignature provider offering this level of flexibility in customization.'), _jsx('p', {}, void 0, 'Connect with sales to learn more about adding this feature or explore the ', _jsx('a', {
                href: '/api/documentation'
            }, void 0, 'API documentation'), '.')), _jsx('div', {
                className: 'm-white-labeling-copy-cta'
            }, void 0, _jsx('div', {
                className: 'quote-and-documentation'
            }, void 0, _jsx('div', {
                className: 'quote-container'
            }, void 0, _jsx('h2', {}, void 0, 'Let\'s get you set up.'), _jsx('div', {
                className: 'get-a-quote',
                id: 'm-get-a-quote'
            }, void 0, _jsx('h3', {}, void 0, _jsx('span', {
                className: 'mobile-cta'
            }, void 0, 'SEE A DEMO'), _jsx('span', {
                className: 'regular-cta'
            }, void 0, 'GET A QUOTE')), _ref4)), _jsx('div', {
                className: 'documentation'
            }, void 0, _jsx('div', {
                className: 'see-documentation'
            }, void 0, _jsx('h3', {}, void 0, 'SEE DOCUMENTATION'), _jsx('button', {
                className: 'bg-cerulean c-white hc-white hbg-velvet-evening'
            }, void 0, _jsx('a', {
                href: '/api/reference#WhiteLabeling'
            }, void 0, 'TAKE ME THERE')))))))));
        }
    }]);

    return WhiteLabelingLandingPage;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/white-labeling.jsx
 ** module id = 865
 ** module chunks = 0
 **/